import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  invoiceRecord: [],
  invoiceRecordById: {},
  invoiceCanCreate: false,
  invoiceCanUpdate: false,
  createdInvoiceid: "",
  nonInvoicedBooking: [],
};

const invoiceRecordSlice = createSlice({
  name: "invoiceRecord",
  initialState,
  reducers: {
    setNonInvoicedBooking(state, action) {
      state.nonInvoicedBooking = action.payload.nonInvoicedBooking;
    },
    setInvoiceCanUpdate(state, action) {
      state.invoiceCanUpdate = action.payload.invoiceCanUpdate;
    },
    setCreatedInvoiceid(state, action) {
      state.createdInvoiceid = action.payload.createdInvoiceid;
    },
    setInvoiceCanCreate(state, action) {
      state.invoiceCanCreate = action.payload.invoiceCanCreate;
    },
    setInvoiceRecord(state, action) {
      state.invoiceRecord = action.payload.invoiceRecord;
    },
    setInvoiceRecordById(state, action) {
      state.invoiceRecordById = action.payload.invoiceRecordById;
    },
  },
});

export const {
  setNonInvoicedBooking,
  setInvoiceCanUpdate,
  setCreatedInvoiceid,
  setInvoiceCanCreate,
  setInvoiceRecord,
  setInvoiceRecordById,
} = invoiceRecordSlice.actions;
export const invoiceRecordSliceReducer = invoiceRecordSlice.reducer;
